import {
  ManageTableProvider,
  QueryBuilderInput,
  useManageTable,
} from '@common';
import { Stack } from '@mantine/core';
import { Route } from 'src/routes/_rootLayout/projects/sales';
import { TicketSalesTable } from './components';
import { useTicketSales, useUpdateSellable } from './hooks';

const SORT_OPTIONS = ['show', 'date', 'copro', 'buyer'];
const DEFAULT_SORT = 'show';

export const TicketSales: React.FC = () => {
  const search = Route.useSearch();
  const {
    initialAst,
    entities,
    savedQueries,
    results,
    pagination,
    isFetching,
    handleQueryAstChange,
    handleSaveQuery,
    shareQuery,
    handleDeleteSavedQuery,
  } = useTicketSales();
  const { handleUpdateSellable } = useUpdateSellable();

  const methods = useManageTable({
    navigateFn: Route.useNavigate(),
    searchParams: search,
    pagination,
    config: {
      accessorOptions: SORT_OPTIONS,
      defaultAccessor: DEFAULT_SORT,
      defaultDirection: 'asc',
    },
  });

  return (
    <Stack gap="md" py="md">
      <QueryBuilderInput
        entities={entities}
        savedQueries={savedQueries}
        onChange={handleQueryAstChange}
        onSaveQuery={handleSaveQuery}
        shareQuery={shareQuery}
        onDeleteSavedQuery={handleDeleteSavedQuery}
        initialAst={initialAst}
      />

      <ManageTableProvider {...methods}>
        <TicketSalesTable
          results={results}
          isPending={isFetching}
          onUpdateSellable={handleUpdateSellable}
        />
      </ManageTableProvider>
    </Stack>
  );
};
